import ListSubheader from '@material-ui/core/ListSubheader';
import styled from '@emotion/styled';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';

export const Container = styled(ListSubheader)`
  ${styleUtils.flex.container({ justifyContent: 'flex-start' })};
  ${styleUtils.typography.copy({ weight: 'medium', lineHeight: 'large' })};
  color: ${theme.color.grayDark};
  padding: ${theme.spacing.xLarge} ${theme.spacing.small};
  position: static;
`;

export const Title = styled('span')`
  color: ${theme.color.black};
  flex-grow: 1;
`;
